<template>
  <Form
      ref="couponForm"
      :model="coupon"
      :rules="ruleValidate"
      :label-width="140"
      label-position="right"
      v-if="coupon"
  >
    <!-- ============ 基础信息 ============ -->
    <Divider orientation="left">基础信息</Divider>

    <FormItem label="三方订单号" prop="box_order_no">
      <Input v-model="coupon.box_order_no" placeholder="请输入三方订单号" clearable />
    </FormItem>

    <FormItem label="公司名称" prop="company_id">
      <dropdown
          @item-click="dropDownClick"
          :isNeedSearch="true"
          :companies="companies"
          :checkObjName="checkObjName"
      />
    </FormItem>

    <FormItem label="券分类" prop="category_id">
      <Select v-model="coupon.category_id" placeholder="请选择券分类" clearable>
        <Option
            v-for="category in categories"
            :value="category.category_id"
            :key="category.category_id"
        >
          {{ category.title }}
        </Option>
      </Select>
    </FormItem>

    <FormItem label="批次号" prop="batch_no">
      <Input v-model="coupon.batch_no" placeholder="请输入批次号" clearable />
    </FormItem>

    <FormItem label="券码" prop="voucher">
      <Input v-model="coupon.voucher" placeholder="请输入券码" clearable />
    </FormItem>

    <FormItem label="礼品卡ASN" prop="gift_card_asn">
      <Input v-model="coupon.gift_card_asn" placeholder="请输入礼品卡ASN" clearable />
    </FormItem>

    <FormItem label="手机号" prop="phone">
      <Input v-model="coupon.phone" placeholder="请输入手机号" clearable />
    </FormItem>

    <FormItem label="会员编号" prop="member_no">
      <Input v-model="coupon.member_no" placeholder="请输入会员编号" clearable />
    </FormItem>

    <!-- ============ 卡券信息 ============ -->
    <Divider orientation="left">卡券信息</Divider>

    <FormItem label="面额(元)" prop="face_value">
      <Input v-model="coupon.face_value" placeholder="请输入面额" clearable />
    </FormItem>

    <FormItem label="可用余额(元)" prop="available_amount">
      <InputNumber
          v-model="coupon.available_amount"
          :min="0"
          :precision="4"
          :step="1"
          placeholder="请输入可用余额"
          style="width: 100%"
      />
    </FormItem>

    <FormItem label="模板编号" prop="templet_no">
      <InputNumber
          v-model="coupon.templet_no"
          :min="0"
          placeholder="请输入模板编号"
          style="width: 100%"
      />
    </FormItem>

    <FormItem label="模板名称" prop="templet_name">
      <Input v-model="coupon.templet_name" placeholder="请输入模板名称" clearable />
    </FormItem>

    <FormItem label="卡券类型编号" prop="card_type_no">
      <Input v-model="coupon.card_type_no" placeholder="请输入卡券类型编号" clearable />
    </FormItem>

    <FormItem label="卡券类型名称" prop="card_type_name">
      <Input v-model="coupon.card_type_name" placeholder="请输入卡券类型名称" clearable />
    </FormItem>

    <FormItem label="卡样编号" prop="card_style_no">
      <Input v-model="coupon.card_style_no" placeholder="请输入卡样编号" clearable />
    </FormItem>

    <FormItem label="卡样名称" prop="card_style_name">
      <Input v-model="coupon.card_style_name" placeholder="请输入卡样名称" clearable />
    </FormItem>

    <!-- ============ 有效期与状态 ============ -->
    <Divider orientation="left">有效期与状态</Divider>

    <FormItem label="生效日期" prop="effect_time">
      <DatePicker
          v-model="coupon.effect_time"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择生效日期"
          style="width: 100%"
      />
    </FormItem>

    <FormItem label="失效日期" prop="expire_time">
      <DatePicker
          v-model="coupon.expire_time"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择失效日期"
          style="width: 100%"
      />
    </FormItem>

    <FormItem label="状态" prop="status">
      <Select v-model="coupon.status" placeholder="请选择状态">
        <Option v-for="item in statusList" :value="item.value" :key="item.value">
          {{ item.label }}
        </Option>
      </Select>
    </FormItem>

    <FormItem label="作废时间" prop="cancel_time">
      <DatePicker
          v-model="coupon.cancel_time"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择作废时间"
          style="width: 100%"
      />
    </FormItem>

    <FormItem label="创建时间" prop="created_at">
      <Input v-model="coupon.created_at" placeholder="-" disabled />
    </FormItem>

    <FormItem label="更新时间" prop="updated_at">
      <Input v-model="coupon.updated_at" placeholder="-" disabled />
    </FormItem>

    <!-- ============ 核销 / 撤销记录 ============ -->
    <Divider orientation="left">核销记录</Divider>

    <FormItem label="核销记录">
      <Table
          :columns="usedColumns"
          :data="validUsedList"
          border
          size="small"
          :no-data-text="'暂无核销记录'"
      />
    </FormItem>

    <FormItem label="撤销记录">
      <Table
          :columns="usedColumns"
          :data="cancelledUsedList"
          border
          size="small"
          :no-data-text="'暂无撤销记录'"
      />
    </FormItem>

    <!-- ============ 操作区 ============ -->
    <!--    <FormItem>-->
    <!--      <Button-->
    <!--          type="primary"-->
    <!--          :loading="butDisabled"-->
    <!--          @click="formHandleSubmit"-->
    <!--      >-->
    <!--        提交-->
    <!--      </Button>-->
    <!--      <Button style="margin-left: 8px" @click="handleReset">重置</Button>-->
    <!--    </FormItem>-->
  </Form>
</template>

<script>
import Dropdown from '../member/components/dropdown.vue'

export default {
  name: 'CouponForm',
  props: {
    coupon: {
      type: Object,
      required: true
    },
    companies: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    checkObjName: {
      type: String,
      default: ''
    }
  },
  components: {
    Dropdown
  },
  data() {
    return {
      butDisabled: false,
      // 状态枚举：0已发放 1已核销 2已绑定 3已废弃 4已过期
      statusList: [
        { value: 0, label: '已发放' },
        { value: 1, label: '已核销' },
        { value: 2, label: '已绑定' },
        { value: 3, label: '已废弃' },
        { value: 4, label: '已过期' }
      ],

      // 核销记录里 transaction_status 的映射
      // 1 正常 / 2 撤销 / 3 被撤销 / 4 退货
      usedStatusMap: {
        1: { text: '正常',   color: 'green' },
        2: { text: '撤销',   color: 'orange' },
        3: { text: '被撤销', color: 'red' },
        4: { text: '退货',   color: 'blue' }
      },

      // 核销记录表格列
      usedColumns: [
        {
          title: '关联订单号',
          key: 'source_order_no',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '业务日期',
          key: 'business_day',
          width: 120
        },
        {
          title: '核销时间',
          key: 'transaction_time',
          width: 170
        },
        {
          title: '核销金额(元)',
          key: 'transaction_amount',
          width: 130,
          align: 'right'
        },
        {
          title: '撤销时间',
          key: 'refund_time',
          width: 170,
          render: (h, { row }) => h('span', row.refund_time || '-')
        },
        {
          title: '油站编码',
          key: 'station_code',
          width: 170,
          tooltip: true
        },
        {
          title: '油站名称',
          key: 'station_name',
          minWidth: 140,
          tooltip: true
        },
        {
          title: '状态',
          key: 'transaction_status',
          width: 100,
          align: 'center',
          render: (h, { row }) => {
            const item = this.usedStatusMap[row.transaction_status] ||
                { text: '未知', color: 'default' }
            return h(
                'Tag',
                { props: { color: item.color } },
                item.text
            )
          }
        }
      ],

      ruleValidate: {
        // box_order_no: [
        //   { required: true, message: '三方订单号不能为空', trigger: 'blur' }
        // ],
        // batch_no: [
        //   { required: true, message: '批次号不能为空', trigger: 'blur' }
        // ],
        // voucher: [
        //   { required: true, message: '券码不能为空', trigger: 'blur' }
        // ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur'
          }
        ],
        status: [
          { required: true, type: 'number', message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    // 归一化后的核销记录（兼容 snake_case / camelCase）
    normalizedUsedList() {
      return this.normalizeUsed(this.coupon.used)
    },
    // 只保留正常核销记录（1 正常、2 撤销、4 退货）
    validUsedList() {
      return this.normalizedUsedList.filter(
          item => [1, 2, 4].indexOf(item.transaction_status) > -1
      )
    },
    // 只保留被撤销的记录（3 被撤销）
    cancelledUsedList() {
      return this.normalizedUsedList.filter(
          item => item.transaction_status === 3
      )
    }
  },
  methods: {
    /**
     * 严格等价于 ?? 的取值：只有 undefined / null 才 fallback
     * 项目 babel 不支持 ?? ，用函数代替
     */
    pick(a, b) {
      return (a === undefined || a === null) ? b : a
    },

    /**
     * 兼容后端两种字段命名（snake_case / camelCase），统一转为 snake_case
     */
    normalizeUsed(list) {
      if (!Array.isArray(list)) return []
      return list.map(item => ({
        ...item,
        transaction_status: this.pick(item.transaction_status, item.transactionStatus),
        source_order_no:     this.pick(item.source_order_no,     item.sourceOrderNo),
        business_day:        this.pick(item.business_day,        item.businessDay),
        transaction_time:    this.pick(item.transaction_time,    item.transactionTime),
        transaction_amount:  this.pick(item.transaction_amount,  item.transactionAmount),
        refund_time:         this.pick(item.refund_time,         item.refundTime),
        station_code:        this.pick(item.station_code,        item.stationCode),
        station_name:        this.pick(item.station_name,        item.stationName)
      }))
    },

    /**
     * 提交表单
     */
    formHandleSubmit() {
      this.$refs.couponForm.validate(valid => {
        if (!valid) {
          this.$Message.error('请输入正确的数据!')
          return
        }
        this.butDisabled = true
        this.$emit('handleSubmit', this.coupon)
        // 防止重复提交，3 秒后恢复
        setTimeout(() => {
          this.butDisabled = false
        }, 3000)
      })
    },

    /**
     * 公司下拉选择
     */
    dropDownClick(e) {
      this.coupon.company_id = e.id
    },

    /**
     * 重置表单
     */
    handleReset() {
      this.$refs.couponForm.resetFields()
    }
  }
}
</script>